import { createBrowserHistory } from 'history';

export const APPLICATION_BUILD_VERSION = '1.0';

export const history = createBrowserHistory();

